 
const getMaximumMonthlyIP = (annualEarnings: number) => {
	const annualIncomeSlice = 60000;
	const higherAnnualIncomeSlice = 100000;
	const preIncapacityGrossEarnings = 39000;
	const higherPreIncapacityEarnings = 59000;

	if(annualEarnings > higherAnnualIncomeSlice) {
		return Math.floor((higherPreIncapacityEarnings + ((annualEarnings - higherAnnualIncomeSlice ) * 0.45)) / 12);
	} else if (annualEarnings > annualIncomeSlice) {
		return Math.floor((preIncapacityGrossEarnings + ((annualEarnings - annualIncomeSlice) * 0.5)) / 12);
	} else if (annualEarnings <= annualIncomeSlice) {
		return Math.floor((annualEarnings * 0.65) / 12);
	}
}

export default getMaximumMonthlyIP;